import { ISelectOption } from "~/shared/ui/Fields/types";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { get } from "lodash";

export const getSelectOptionVal = (value: ISelectOption) =>
  get(value, "value", undefined);

export const getFiltersVal = <T extends "number" | "string" | undefined>(
  arr: ISelectOption[],
  type?: T
): T extends "number"
  ? number[]
  : T extends "string"
  ? string[]
  : (string | number)[] => {
  return (arr ?? []).map((el) => {
    if (typeof el !== "object") {
      switch (type) {
        case "number":
          return Number(el);
        case "string":
          return String(el);
        default:
          return el;
      }
    }
    switch (type) {
      case "number":
        return Number(el.value);
      case "string":
        return String(el.value);
      default:
        return el.value;
    }
  }) as any;
};

export const getDealerGroupFilter = (
  filterBy: keyof FILTER_BY,
  itemsForService: string[]
) => {
  const defaultVal = {
    ids: [],
    cities: [],
    FOs: [],
    countries: [],
    subjects: [],
  };
  switch (filterBy) {
    case FILTER_BY.DEALER:
      return { ...defaultVal, ids: itemsForService };
    case FILTER_BY.CITY:
      return { ...defaultVal, cities: itemsForService };
    case FILTER_BY.FO:
      return { ...defaultVal, FOs: itemsForService };
    case FILTER_BY.COUNTRY:
      return { ...defaultVal, countries: itemsForService };
    case FILTER_BY.AREA:
      return { ...defaultVal, subjects: itemsForService };
  }
};

export const resolveGroupFilter = (filterBy: keyof FILTER_BY) => {
  switch (filterBy) {
    case FILTER_BY.FO:
      return "fo";
    case FILTER_BY.AREA:
      return "subject";
    case FILTER_BY.CITY:
      return "city";
    case FILTER_BY.DEALER:
      return "id";
    case FILTER_BY.COUNTRY:
      return "country";
  }
};
